import { BaseEntity } from '../../../models';
import { usuarioAtivo } from '../usuario-situacao';

export class UsuarioExpedicao implements BaseEntity {
    readonly id: number;
    idUsuarioPai: number;
    nome: string;
    situacao: number;

    constructor() {
        this.situacao = usuarioAtivo.id;
    }
}
